import React, { useEffect, useRef } from 'react';
import { styles } from './styles';
export function GridHeaderCellWithResizeTrigger(props) {
    var tearDownRef = useRef(null);
    var startMove = function (e) {
        var _a, _b;
        (_a = tearDownRef.current) === null || _a === void 0 ? void 0 : _a.call(tearDownRef);
        if (e.button !== 0) {
            return;
        }
        var x = e.clientX, y = e.clientY;
        (_b = props.onDragStart) === null || _b === void 0 ? void 0 : _b.call(props, { x: x, y: y });
        var stop = function (e) {
            var _a, _b;
            (_a = props.onDragEnd) === null || _a === void 0 ? void 0 : _a.call(props, { x: e.clientX, y: e.clientY });
            (_b = tearDownRef.current) === null || _b === void 0 ? void 0 : _b.call(tearDownRef);
            tearDownRef.current = null;
        };
        var mouseMoveHandler = function (e) {
            requestAnimationFrame(function () {
                var _a, _b, _c, _d, _e;
                try {
                    (_b = (_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.empty) === null || _b === void 0 ? void 0 : _b.call(_a);
                    (_d = (_c = window.getSelection()) === null || _c === void 0 ? void 0 : _c.removeAllRanges) === null || _d === void 0 ? void 0 : _d.call(_c);
                }
                catch (_f) { }
                (_e = props.onMouseMove) === null || _e === void 0 ? void 0 : _e.call(props, { x: e.clientX, y: e.clientY });
            });
        };
        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('contextmenu', stop);
        document.addEventListener('mouseup', stop);
        document.addEventListener('mousedown', stop);
        document.addEventListener('mouseleave', stop);
        document.addEventListener('keydown', stop);
        document.addEventListener('blur', stop);
        tearDownRef.current = function () {
            document.removeEventListener('mousemove', mouseMoveHandler);
            document.removeEventListener('contextmenu', stop);
            document.removeEventListener('mousedown', stop);
            document.removeEventListener('mouseup', stop);
            document.removeEventListener('mouseleave', stop);
            document.removeEventListener('keydown', stop);
            document.removeEventListener('blur', stop);
        };
    };
    useEffect(function () {
        return function () {
            var _a;
            (_a = tearDownRef.current) === null || _a === void 0 ? void 0 : _a.call(tearDownRef);
        };
    }, []);
    return (React.createElement("div", { className: styles.wrapper },
        props.content,
        React.createElement("div", { className: styles.trigger, onMouseDown: startMove })));
}
//# sourceMappingURL=GridHeaderCellWithResizeTrigger.js.map